import * as React from "react"

function BlueBackIcon({ color }) {
    return (
        <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.692329 6.66004C0.539268 6.66004 0.386207 6.59882 0.263758 6.49168C0.0188601 6.26208 0.0188601 5.86412 0.248452 5.61923L5.31478 0.369227C5.54437 0.124329 5.94233 0.124329 6.18723 0.353921C6.43213 0.583513 6.43213 0.981472 6.20253 1.22637L1.13621 6.47637C1.01376 6.59882 0.845391 6.66004 0.692329 6.66004Z" fill="#00B3FF" />
            <path d="M14.3878 6.61511H0.612245C0.27551 6.61511 0 6.3396 0 6.00287C0 5.66614 0.27551 5.39062 0.612245 5.39062H14.3878C14.7245 5.39062 15 5.66614 15 6.00287C15 6.3396 14.7245 6.61511 14.3878 6.61511Z" fill="#00B3FF" />
            <path d="M5.75866 11.8182C5.60559 11.8182 5.43723 11.757 5.31478 11.6345L0.248452 6.47637C0.0188601 6.23147 0.0188601 5.84882 0.263758 5.60392C0.508656 5.37433 0.891309 5.37433 1.13621 5.61923L6.20253 10.7774C6.43213 11.0223 6.43213 11.4049 6.18723 11.6498C6.06478 11.757 5.91172 11.8182 5.75866 11.8182Z" fill="#00B3FF" />
        </svg>
    )
}

export default BlueBackIcon
